import emailjs from '@emailjs/browser';
import { getEnvVar } from './api.js';

const EMAILJS_SERVICE_ID = getEnvVar('REACT_APP_EMAILJS_SERVICE_ID');
const EMAILJS_TEMPLATE_ID = getEnvVar('REACT_APP_EMAILJS_TEMPLATE_ID');
const EMAILJS_PUBLIC_KEY = getEnvVar('REACT_APP_EMAILJS_PUBLIC_KEY');

const isConfigured = Boolean(
  EMAILJS_SERVICE_ID
  && EMAILJS_TEMPLATE_ID
  && EMAILJS_PUBLIC_KEY,
);

export const sendContactEmail = async (templateParams) => {
  if (!isConfigured) {
    console.warn('EmailJS is not configured; skipping email send.');
    return;
  }

  await emailjs.send(
    EMAILJS_SERVICE_ID,
    EMAILJS_TEMPLATE_ID,
    templateParams,
    {
      publicKey: EMAILJS_PUBLIC_KEY,
    },
  );
};

export const isEmailNotificationsEnabled = isConfigured;


